/**
 * Dark/light theme toggle with radial overlay animation.
 */

import {
  THEME_TRANSITION_DURATION_MS,
  THEME_APPLY_DELAY_MS
} from './constants.js';

function updateThemeLabel(theme) {
  const label = document.getElementById('themeToggleLabel');
  if (label) label.textContent = theme === 'dark' ? 'Light' : 'Dark';
}

function setupThemeToggle(toggleElement) {
  toggleElement.addEventListener('click', () => {
    const currentTheme = document.documentElement.getAttribute('data-theme');
    const newTheme = currentTheme === 'dark' ? 'light' : 'dark';

    // Bloom from center of viewport
    const centerX = window.innerWidth / 2;
    const centerY = window.innerHeight / 2;

    const maxDistance = Math.max(
      Math.sqrt(centerX ** 2 + centerY ** 2),
      Math.sqrt((window.innerWidth - centerX) ** 2 + centerY ** 2),
      Math.sqrt(centerX ** 2 + (window.innerHeight - centerY) ** 2),
      Math.sqrt((window.innerWidth - centerX) ** 2 + (window.innerHeight - centerY) ** 2)
    );

    const overlay = document.createElement('div');
    overlay.className = 'theme-transition-overlay';
    overlay.style.left = `${centerX}px`;
    overlay.style.top = `${centerY}px`;
    overlay.style.width = `${maxDistance * 2}px`;
    overlay.style.height = `${maxDistance * 2}px`;
    overlay.style.marginLeft = `-${maxDistance}px`;
    overlay.style.marginTop = `-${maxDistance}px`;
    overlay.style.backgroundColor = newTheme === 'dark' ? '#0a0a0a' : '#ffffff';

    document.body.appendChild(overlay);
    void overlay.offsetWidth;

    requestAnimationFrame(() => overlay.classList.add('active'));

    setTimeout(() => {
      document.documentElement.setAttribute('data-theme', newTheme);
      localStorage.setItem('theme', newTheme);
      updateThemeLabel(newTheme);
    }, THEME_APPLY_DELAY_MS);

    setTimeout(() => overlay.remove(), THEME_TRANSITION_DURATION_MS);
  });
}

/**
 * Initialize theme from localStorage and attach toggles.
 * Restores user preference, removes stale overlays, binds theme buttons.
 */
export function initializeTheme() {
  const savedTheme = localStorage.getItem('theme') || 'dark';
  document.documentElement.setAttribute('data-theme', savedTheme);
  updateThemeLabel(savedTheme);

  document.querySelectorAll('.theme-transition-overlay').forEach((el) => el.remove());

  const el = document.getElementById('themeToggle');
  if (el && !el.hasAttribute('data-initialized')) {
    el.setAttribute('data-initialized', 'true');
    setupThemeToggle(el);
  }
}
